module.exports = __webpack_public_path__ + "img/user-13.737ef51d.jpg";